import { toolGroups } from '../data';

export default function About() {
  return (
    <section id="tools" className="section">
      <div className="container">
        <div className="section__divider"><span>Tools</span></div>
        <p className="section__lead">I’m pragmatic about tools. I care less about the label and more about whether the stack helps me catch risk earlier, debug faster, and ship with confidence.</p>

        <div className="about__grid">
          <div className="tools-grid">
            {toolGroups.map((group, i) => (
              <div key={i} className="tool-group">
                <p className="tool-group__label">{group.label}</p>
                <p className="tool-group__items">
                  {group.tools.map((t) => t.name).join(', ')}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
